import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useApp } from '../lib/AppContext';
import { deviceContext } from '../lib/device';
import { isCoachPath } from '../lib/mode';

const GAP_MS = 5 * 60 * 1000;

// Tells the server the app was opened (UserEvent "app_open"), with the device it runs on, for the admin user page:
// on start and whenever the app comes back to the front, at most once per 5 minutes (the server skips repeats too).
// Mounted only in your own app, never on a share link or a coach's view of a student. Fire-and-forget: nothing waits
// for it and a failure is ignored. Renders nothing.
export default function ActivityPing() {
  const { api, native, base } = useApp();
  const { pathname } = useLocation();
  const path = useRef(pathname);
  path.current = pathname;
  const last = useRef(0);

  useEffect(() => {
    const ping = async () => {
      if (Date.now() - last.current < GAP_MS) return;
      last.current = Date.now();
      try {
        const after = base && path.current.startsWith(base) ? path.current.slice(base.length) || '/' : path.current;
        const data = await deviceContext(native);
        await api.post('/events', { kind: 'app_open', mode: isCoachPath(after) ? 'coach' : 'personal', data }, { quiet: true });
      } catch {
        // Offline or signed out: this open just isn't counted.
      }
    };
    ping();
    const onVisible = () => document.visibilityState === 'visible' && ping();
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [api, native, base]);

  return null;
}
